import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Grid } from '@material-ui/core';
import { Form, notification, Button, Input, InputNumber } from 'antd';
import MainContainer from '../../components/MainContainer';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { green } from '@material-ui/core/colors';

@inject(
  'loginStore',
  'CmsLaundryServiceStore',
  'CmsLanguageStore'
)
@observer
class CmsLaundryService extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    this.props.loginStore.authenticateAdmin().then(response => {
      if (!response) {
        this.props.history.push('/admin/login');
      }
    });
    
    this.props.CmsLanguageStore.getActives().then(() => {
      this.props.CmsLaundryServiceStore.getData();
    });
  }

  create = () => {
    this.props.CmsLaundryServiceStore.create().then(resp => {
      if (!resp.isError) {
        this.props.CmsLaundryServiceStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Laundry Service is successfully updated.',
          duration: 1
        });
      }
    });
  }

  update = (id) => {
    this.props.CmsLaundryServiceStore.update(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsLaundryServiceStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Laundry Service is successfully updated.',
          duration: 1
        });
      }
    });
  }

  delete = (id) => {
    this.props.CmsLaundryServiceStore.delete(id).then(resp => {
      if (!resp.isError) {
        this.props.CmsLaundryServiceStore.getData();
        notification['success']({
          message: 'Success',
          description: 'Laundry Service is successfully deleted.',
          duration: 1
        });
      }
    });
  }

  render() {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const {
      data,
    } = this.props.CmsLaundryServiceStore;

    return (
      <MainContainer title='Customize Laundry Service' menukey='laundry-service'>
        <>
          {
            activeLanguages
              ?
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Form.Item>
                    <div style={{ textAlign: 'right' }}>
                      <button
                        style={{ border: 'none', background: 'none', cursor: 'pointer' }}
                        onClick={() => this.props.CmsLaundryServiceStore.initCreate(activeLanguages)}>
                        <AddCircleIcon style={{ color: green[500], fontSize: 45 }} />
                      </button>
                    </div>
                    <div className='stm-display-flex stm-stm-width-100-percent stm-background-white-three stm-font-size-14 stm-line-height-18 stm-font-weight-bold stm-color-495057 stm-border-bottom-width-2 stm-border-bottom-color-white-two stm-border-bottom-style-solid'>
                      <div className='stm-width-10-percent stm-padding-8'>Sort</div>
                      <>
                        {
                          activeLanguages.map(lang => {
                            return (
                              <div key={lang.id} className='stm-width-20-percent stm-padding-8'>{lang.name}</div>
                            )
                          })
                        }
                      </>
                      <div className='stm-width-20-percent stm-padding-8'>Action</div>
                    </div>
                    <>
                      {
                        data.map(item => {
                          return (
                            <>
                              <div
                                key={item.id}
                                className='stm-display-flex stm-stm-width-100-percent  stm-font-size-14 stm-line-height-18 stm-border-top-width-1 stm-border-top-color-white-two  stm-border-top-style-solid stm-background-white'
                              >
                                <div className='stm-width-10-percent stm-padding-8'>
                                  <InputNumber
                                    min={0}
                                    value={item.sort}
                                    onChange={(value) => this.props.CmsLaundryServiceStore.setsort(item.id, value)}
                                    className='stm-width-64' />
                                </div>
                                <>
                                  {
                                    activeLanguages.map(lang => {
                                      return (
                                        <div className='stm-width-20-percent stm-padding-8'>
                                          <Input
                                            value={item.laundryServiceLanguages.find(fi => fi.languageId === lang.id).name}
                                            onChange={(e) => this.props.CmsLaundryServiceStore.setname(item.id, lang.id, e.target.value)}
                                            className='' />
                                        </div>
                                      )
                                    })
                                  }
                                </>
                                <div className='stm-width-20-percent stm-padding-8'>
                                  <>
                                    {
                                      item.id === 0
                                        ?
                                        <>
                                          <Button
                                            type='primary'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32 stm-margin-right-16'
                                            onClick={this.create}>Create</Button>
                                          <Button
                                            type='default'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                            onClick={() => this.props.CmsLaundryServiceStore.cancel()}>Cancel</Button>
                                        </>
                                        :
                                        <>
                                          <Button
                                            type='primary'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32 stm-margin-right-16'
                                            onClick={() => this.update(item.id)}>Edit</Button>
                                          <Button
                                            type='danger'
                                            className='stm-font-size-16 line-height-20 stm-width-100 stm-height-32'
                                            onClick={() => this.delete(item.id)}>Delete</Button>
                                        </>
                                    }

                                  </>
                                </div>
                              </div>
                            </>
                          )
                        })
                      }
                    </>
                  </Form.Item>
                </Grid>
              </Grid>
              :
              null
          }
        </>
      </MainContainer>
    )
  }
}

export default CmsLaundryService;